<template>
  <v-app style="position: relative; width: 100%; height: 100%;">
    <v-toolbar dark v-if="$route.name" color="grey lighten-5" app>
      <v-icon color="secondary" class="big-icon">local_play</v-icon>
      <div class="display-1 ml-4 secondary--text">{{$t(`title_${$route.name}`)}}</div>
      <v-spacer />
      <logo theme="light" class="login-logo" height="60" style="height: 60px; width: auto;"/>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height class="pa-0" style="max-width: 100% !important;">
        <v-layout column align-center>
          <router-view/>
          <div class="grey--text pa-2 text-xs-center caption">
            Copyright © easygoband World S.L. 2020 v{{pjson.version}}
          </div>
        </v-layout>
      </v-container>
    </v-content>
    <v-snackbar
      v-model="message.show"
      bottom
      :color="message.color"
      :timeout="message.timeout"
    >
      {{ message.text }}
    </v-snackbar>
  </v-app>
</template>
<script>
import pjson from '@/../package.json'
import { mapState } from 'vuex'
export default {
  components: {
    Logo: () => import('@/components/Logo.vue')
  },
  computed: {
    ...mapState(['message'])
  },
  data () {
    return {
      pjson
    }
  }
}
</script>
<style lang="scss">
html, body {
  overflow: hidden !important;
  height: 100%;
}

.big-icon {
  font-size: 38px !important;
}
.flex-none {
  flex: none !important;
}
.strikethrough {
  text-decoration: line-through;
}
// VUETIFY
.v-content {
  max-height: 100%;
  .v-content__wrap {
    overflow: auto;
    position: relative;
  }
}.application--wrap {
  min-height: 100% !important;
}

.v-btn:not(.v-btn--floating):not(.v-btn--icon) {
  border-radius: 5px !important;
}

.v-btn.primary {
  background: linear-gradient(to right top, #00D7D7, #241DBA);
}
</style>
